import {
    GET_BY_CUSTOMER
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    detail: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BY_CUSTOMER: {
            return {
                ...state,
                detail: action.payload || null,
            };
        }

        default:
            return state;
    }
};
